import React from "react"
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/core/styles";
import TextInput from "components/TextInput";

const useStyle = makeStyles(theme => ({
    root: {
        width: 800
    }
}))


function OfferTextInput(
    {
        id,
        formikProps,
        disabled
    }) {

    const classes = useStyle();
    return (
        <TextInput
            className={classes.root}
            id={id + ".value"}
            label={Tr('enter_value_text')}
            formikProps={formikProps}
            multiline
            disabled={disabled}
        />
    )


}

OfferTextInput.propTypes = {
    id: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired
}

export default OfferTextInput;